var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33538 0.621582C6.66601 0.637434 6.94061 0.785384 7.09752 1.08657C7.26004 1.39832 7.22641 1.6995 7.00786 1.97955C6.95742 2.04296 6.89578 2.0958 6.83413 2.15392C5.36029 3.5436 3.89204 4.93327 2.41259 6.31767C2.2837 6.4392 2.26689 6.5026 2.40699 6.6347C3.90325 8.03494 5.39391 9.44576 6.89017 10.8513C7.17037 11.1102 7.32168 11.4008 7.204 11.776C7.02467 12.3572 6.29055 12.5738 5.78619 12.1987C5.72455 12.1564 5.67411 12.1036 5.61807 12.0507C3.89204 10.418 2.16602 8.79055 0.445593 7.16838C-0.0419538 6.70868 -0.0363499 6.25426 0.445593 5.79456C2.17162 4.1671 3.89765 2.53965 5.61807 0.912198C5.80861 0.732545 6.02716 0.621582 6.33538 0.621582Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.15629,
    height: 11.7568,
    fill: "white",
    transform: "translate(0.0810547 0.621582)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back_button.77bb290382958bdab843150a4415a673.svg";
export { ForwardRef as ReactComponent };